module.exports = __webpack_public_path__ + "img/vertical_3_1_5012.477a5de8.png";